import BgDecoration from "../shared/components/bgDecoration/bgDecoration";
import Subpage from "../shared/components/subpage/subpage";
import Heading1, {
  Heading1Type,
} from "../shared/components/typo/heading1/heading1";
import Heading2 from "../shared/components/typo/heading2/heading2";
import Heading3 from "../shared/components/typo/heading3/heading3";
import ImageWithIcon, {
  ImageWithIconType,
} from "../shared/components/imageWithIcon/imageWithIcon";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Image from "next/image";

function OptimalPicture() {
  return (
    <BgDecoration top={true}>
      <Subpage>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-5">
                <Heading1
                  type={Heading1Type.alternative}
                  large
                  className="mb-3 pb-2"
                >
                  Target scanning and analysing
                </Heading1>
                <Heading2>How to achieve best results</Heading2>
                <div className="mb-2" />
              </div>
            </div>
            <div className="row mt-5 pt-3">
              <div className="col-lg-10 offset-lg-1">
                <div className="row mb-5">
                  <div className="col-lg-5">
                    <Heading3 greyed className="mb-4">
                      1. <br />
                      Use contrast background as possible.
                    </Heading3>
                  </div>
                  <div className="col-lg-6 offset-lg-1">
                    <div className="row">
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.good}>
                          <Image
                            src="/images/optimal-picture/1-ok.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.bad}>
                          <img
                            src="/images/optimal-picture/1-wrong.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-5">
                  <div className="col-lg-5 offset-lg-1 o-lg-2">
                    <Heading3 greyed className="mb-4">
                      2. <br />
                      We always need the whole black part of the target.
                    </Heading3>
                  </div>
                  <div className="col-lg-6 o-lg-1">
                    <div className="row">
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.good}>
                          <img
                            src="/images/optimal-picture/2-ok.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.bad}>
                          <img
                            src="/images/optimal-picture/2-wrong.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-5">
                  <div className="col-lg-5">
                    <Heading3 greyed className="mb-4">
                      3. <br />
                      Do not take pictures under big angle.
                    </Heading3>
                  </div>
                  <div className="col-lg-6 offset-lg-1">
                    <div className="row">
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.good}>
                          <img
                            src="/images/optimal-picture/3-ok.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.bad}>
                          <img
                            src="/images/optimal-picture/3-wrong.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-5">
                  <div className="col-lg-5 offset-lg-1 o-lg-2">
                    <Heading3 greyed className="mb-4">
                      4. <br />
                      Straighten bent targets that create an inner shadow.
                    </Heading3>
                  </div>
                  <div className="col-lg-6 o-lg-1">
                    <div className="row">
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.good}>
                          <img
                            src="/images/optimal-picture/4-ok.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.bad}>
                          <img
                            src="/images/optimal-picture/4-wrong.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-5">
                  <div className="col-lg-5">
                    <Heading3 greyed className="mb-4">
                      5. <br />
                      Take pictures in good light, not in the dark or too shady.
                    </Heading3>
                  </div>
                  <div className="col-lg-6 offset-lg-1">
                    <div className="row">
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.good}>
                          <img
                            src="/images/optimal-picture/5-ok.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                      <div className="col-6">
                        <ImageWithIcon type={ImageWithIconType.bad}>
                          <img
                            src="/images/optimal-picture/5-wrong.jpg"
                            className="img-fluid"
                            alt=""
                            width="750"
                            height="1623"
                          />
                        </ImageWithIcon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Subpage>
    </BgDecoration>
  );
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default OptimalPicture;
